import React from "react";
import Page from "components/Page";
import axios from "axios";
import AppConstants from "AppConstants";
import { ReactTitle } from "react-meta-tags";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Loading from "assets/img/loader.gif";
import NumberFormat from "react-number-format";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactDOM from "react-dom";
import moment from "moment";
import { connect } from "react-redux";
import Switch from "react-switch";
class EditChild extends React.Component {
  constructor() {
    super();
    this.state = {
      name: "",
      organization: "",
      school: "",
      email: "",
      address2: "",
      address1: "",
      dob: "",
      phone: "",
      graduatedate: "",
      guardianaddress: "",
      guardianphone: "",
      guardian: "",
      flanguage: "",
      guardianflang: "",
      status: false,
      guardianemail: "",
      errors: {},
      usertype: "",
      to_be_mentor: "",
      years: "",
      errMsg: "",
      loading: "",
      read: false,
      gender: "",
      programs: [],
      program: "",
      nameError: false,
      organization_error: false,
      school_error: false,
      email_error: false,
      address_error2: false,
      address_error1: false,
      dob_error: false,
      phone_error: false,
      graduatedate_error: false,
      guardianaddress_error: false,
      guardianphone_error: false,
      guardian_error: false,
      flanguage_error: false,
      guardianflang_error: false,
      status_error: false,
      guardianemail_error: false,
      usertype_error: false,
      to_be_mentor_error: false,
      gender_error: false,
      program_error: false,
      grade_error: false,
      email_error1: false,
      guardianemail_error1: false,
      city: "",
      city_error: false,
      zipcode: "",
      zipcode_error: false,
      state: "",
      state_error: false,
      languages: [],
      pastProgram: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // this.inputChangedHandlerContact = this.inputChangedHandlerContact.bind(this);
    // this.handleStartdateChange = this.handleStartdateChange.bind(this);
    // this.handleDateofbirth = this.handleDateofbirth.bind(this);
    // this.handleChange = this.handleChange.bind(this);
  }
  // handleChange(checked) {
  //     // if(e.target.name == "status"){
  //         // if(checked !== ""){
  //         //     this.setState({status_error:false})
  //         // }
  //     // }
  //     this.setState({ status : checked });
  //   }
  // handleDateofbirth(bday){
  //     if(bday != ""){
  //         this.setState({dob_error:false})
  //     }
  //     var years = moment().diff(bday, 'years');
  //     this.setState({dob:bday,years:years})
  // }
  // handleStartdateChange(date){
  //     if(date != ""){
  //         this.setState({graduatedate_error:false})
  //     }
  //     this.setState({graduatedate:date})
  // }
  // inputChangedHandlerContact=(values)=>{
  //     if(values.value != ""){
  //         this.setState({phone_error:false})
  //     }
  //     this.setState({
  //         phone: values.value,
  //     });
  // }

  handleInputChange(e) {
    let errors = {};
    this.setState({
      [e.target.name]: e.target.value.trimLeft(/(^\s+|\s+$)/g, ""),
    });
  }

  // handlechildmail(e){
  //     let errors = {};
  //     let formIsValid = true;
  //     if(e.target.value){
  //         if(e.target.value == this.state.guardianemail){
  //             formIsValid = false;
  //             errors["email"] = "Child and parent mail should not be match";
  //             this.setState({email_error1 : true})
  //         }
  //     }
  //     this.setState({errors1: errors});
  //     return formIsValid;
  // }

  // handleparentmail(e){
  //     if(e.target.value){
  //         fetch(AppConstants.API+'/child/getParentInfo/'+e.target.value)
  //         .then(res => {
  //            if(res.status == 200){
  //                return res.json()
  //            }
  //         }).then(result=>{
  //                 if(result.Status == "Success"){
  //                     if(result.data[0]){
  //                         this.setState({
  //                             read : true,
  //                             guardian : result.data[0].parent_name,
  //                             guardianphone : result.data[0].phone,
  //                             guardianflang : result.data[0].first_language,
  //                             guardianaddress : result.data[0].address
  //                         })
  //                     }
  //                     else{
  //                         this.setState({
  //                             read : false,
  //                             guardian : "",
  //                             guardianphone : "",
  //                             guardianflang : "",
  //                             guardianaddress : ""
  //                         })
  //                     }
  //                 }

  //         })
  //         let errors = {};
  //         let formIsValid = true;
  //         if(e.target.value == this.state.email){
  //             formIsValid = false;
  //             errors["guardianemail"] = "Parent and child mail should not be match" ;
  //             this.setState({guardianemail_error1 : true})
  //         }
  //         this.setState({errors1: errors});
  //         return formIsValid;
  //     }
  // }
  // handleValidation(){
  //     let errors = {};
  //     let formIsValid = true;
  //     // if (!this.state.status){
  //     //     formIsValid = false;
  //     //     errors["status"] = "Please select status";
  //     //     ReactDOM.findDOMNode(this.refs.status).focus();
  //     // }
  //     if (!this.state.guardianflang){
  //         formIsValid = false;
  //         errors["guardianflang"] = "Please select parent first language";
  //         ReactDOM.findDOMNode(this.refs.guardianflang).focus();
  //     }
  //     if(this.state.usertype == "Alumni"){
  //         if (!this.state.to_be_mentor){
  //             formIsValid = false;
  //             errors["to_be_mentor"] = "Please choose one";
  //             ReactDOM.findDOMNode(this.refs.to_be_mentor).focus();
  //         }
  //     }
  //     if (!this.state.guardianaddress){
  //         formIsValid = false;
  //         errors["guardianaddress"] = "Please enter parent address";
  //         ReactDOM.findDOMNode(this.refs.guardianaddress).focus();
  //     }
  //     if (!this.state.guardianphone){
  //         formIsValid = false;
  //         errors["guardianphone"] = "Please enter parent phone number";
  //         ReactDOM.findDOMNode(this.refs.guardianphone).focus();
  //     }
  //     if(this.state.years < 18){
  //         if(!this.state.guardianemail){
  //             formIsValid = false;
  //             errors["guardianemail"] = "Please enter parent email";
  //             ReactDOM.findDOMNode(this.refs.guardianemail).focus();
  //         }
  //         if(this.state.guardianemail !== ""){
  //             let lastAtPos = this.state.guardianemail.lastIndexOf('@');
  //             let lastDotPos = this.state.guardianemail.lastIndexOf('.');

  //             if (!(lastAtPos < lastDotPos && lastAtPos > 0 && this.state.guardianemail.indexOf('@@') == -1 && lastDotPos > 2 && (this.state.guardianemail.length - lastDotPos) > 2)) {
  //               formIsValid = false;
  //               errors["guardianemail"] = "Please enter valid email";
  //               ReactDOM.findDOMNode(this.refs.guardianemail).focus();
  //             }
  //         }
  //     }
  //     if (!this.state.guardian){
  //         formIsValid = false;
  //         errors["guardian"] = "Please enter parent name";
  //         ReactDOM.findDOMNode(this.refs.guardian).focus();
  //     }
  //     if (!this.state.program){
  //         formIsValid = false;
  //         errors["program"] = "Please select program";
  //         ReactDOM.findDOMNode(this.refs.program).focus();
  //     }
  //     if (!this.state.flanguage){
  //         formIsValid = false;
  //         errors["flanguage"] = "Please select first language";
  //         ReactDOM.findDOMNode(this.refs.flanguage).focus();
  //     }
  //     if (!this.state.phone){
  //         formIsValid = false;
  //         errors["phone"] = "Please enter phone";
  //         ReactDOM.findDOMNode(this.refs.phone).focus();
  //     }
  //     else if(this.state.phone.length!=10){
  //         formIsValid = false;
  //         errors["phone"] = "Please enter 10 digits phone number";
  //         ReactDOM.findDOMNode(this.refs.phone).focus();
  //     }
  //     if (!this.state.zipcode){
  //         formIsValid = false;
  //         errors["zipcode"] = "Please enter zipcode";
  //         ReactDOM.findDOMNode(this.refs.zipcode).focus();
  //     }
  //     if (!this.state.city){
  //         formIsValid = false;
  //         errors["city"] = "Please enter city";
  //         ReactDOM.findDOMNode(this.refs.city).focus();
  //     }
  //     if (!this.state.state){
  //         formIsValid = false;
  //         errors["state"] = "Please enter state";
  //         ReactDOM.findDOMNode(this.refs.state).focus();
  //     }
  //     if (!this.state.address2){
  //         formIsValid = false;
  //         errors["address2"] = "Please enter address";
  //         ReactDOM.findDOMNode(this.refs.address2).focus();
  //     }
  //     if (!this.state.address1){
  //         formIsValid = false;
  //         errors["address1"] = "Please enter address";
  //         ReactDOM.findDOMNode(this.refs.address1).focus();
  //     }
  //     if (!this.state.email){
  //         formIsValid = false;
  //         errors["email"] = "Please enter email";
  //         ReactDOM.findDOMNode(this.refs.email).focus();
  //     }
  //     if(this.state.email !== ""){
  //         let lastAtPos = this.state.email.lastIndexOf('@');
  //         let lastDotPos = this.state.email.lastIndexOf('.');

  //         if (!(lastAtPos < lastDotPos && lastAtPos > 0 && this.state.email.indexOf('@@') == -1 && lastDotPos > 2 && (this.state.email.length - lastDotPos) > 2)) {
  //           formIsValid = false;
  //           errors["email"] = "Please enter valid email";
  //           ReactDOM.findDOMNode(this.refs.email).focus();
  //         }
  //     }
  //     if (!this.state.grade){
  //         formIsValid = false;
  //         errors["grade"] = "Please enter grade of child";
  //         ReactDOM.findDOMNode(this.refs.grade).focus();
  //     }
  //     if (!this.state.school){
  //         formIsValid = false;
  //         errors["school"] = "Please enter school";
  //         ReactDOM.findDOMNode(this.refs.school).focus();
  //     }
  //     if (!this.state.dob){
  //         formIsValid = false;
  //         errors["dob"] = "Please enter date of birth";
  //         // ReactDOM.findDOMNode(this.refs.dob).focus();
  //     }
  //     if (!this.state.graduatedate){
  //         formIsValid = false;
  //         errors["graduatedate"] = "Please enter graduated date or year";
  //         // ReactDOM.findDOMNode(this.refs.graduatedate).focus();
  //     }
  //     if (!this.state.organization){
  //         formIsValid = false;
  //         errors["organization"] = "Please enter organization";
  //         ReactDOM.findDOMNode(this.refs.organization).focus();
  //     }
  //     if (!this.state.gender){
  //         formIsValid = false;
  //         errors["gender"] = "Please select your gender";
  //         ReactDOM.findDOMNode(this.refs.gender).focus();
  //     }
  //     if (!this.state.name){
  //         formIsValid = false;
  //         errors["name"] = "Please enter name";
  //         ReactDOM.findDOMNode(this.refs.name).focus();
  //     }
  //     if (!this.state.usertype){
  //         formIsValid = false;
  //         errors["usertype"] = "Please select user type";
  //         ReactDOM.findDOMNode(this.refs.usertype).focus();
  //     }
  //     this.setState({
  //         errors: errors,
  //         nameError:true,
  //         organization_error:true,
  //         email_error :true,
  //         gender_error : true,
  //         address_error2 : true,
  //         address_error1 : true,
  //         usertype_error : true,
  //         graduatedate_error : true,
  //         graduation_year : true,
  //         guardian_error : true,
  //         guardianaddress_error : true,
  //         guardianemail_error : true,
  //         guardianflang_error : true,
  //         guardianphone_error : true,
  //         school_error : true,
  //         dob_error : true,
  //         phone_error : true,
  //         flanguage_error : true,
  //         status_error : true,
  //         to_be_mentor_error : true,
  //         program_error : true,
  //         grade_error : true,
  //         city_error : true,
  //         state_error : true,
  //         zipcode_error : true
  //     });
  //     return formIsValid;
  // }
  handleSubmit(e) {
    e.preventDefault();
    let formval = {};
    // if(this.handleValidation()){

    this.setState({ loading: 1 });
    formval = {
      // 'name': this.state.name,
      // 'email': this.state.email,
      // 'address2': this.state.address2,
      // 'address1': this.state.address1,
      // 'phone': this.state.phone,
      // 'date_of_birth': this.state.dob,
      // 'graduation_year': this.state.graduatedate,
      // 'gaurdian_phone': this.state.gaurdianphone,
      // 'gaurdian_name': this.state.gaurdian,
      // 'gaurdian_address':this.state.gaurdianaddress,
      // 'gauradianflang' : this.state.guardianflang,
      // 'gender': this.state.gender,
      // 'firstlanguage': this.state.flanguage,
      // 'organization' : this.state.organization,
      // 'role_id': 3,
      // 'role_type': 'child',
      // 'grade':this.state.grade,
      // 'school':this.state.school,
      // 'status' : this.state.status,
      // 'guardianemail' : this.state.guardianemail,
      // 'usertype':this.state.usertype,
      // 'to_be_mentor' : this.state.to_be_mentor,
      program: this.state.program,
      pastProgram: this.state.pastProgram,
      // 'city':this.state.city,
      // 'state':this.state.state,
      // 'zipcode':this.state.zipcode
    };
    axios
      .post(
        AppConstants.API +
          "/child/childProgramUpdate/" +
          this.props.match.params.id,
        formval
      )
      .then((res) => {
        if (res.data.Status == "Success") {
          setTimeout((e) => {
            this.props.history.push("/allChildren");
          }, 2000);
          setTimeout(() => {
            this.setState({
              loading: "",
              errMsg: (
                <div className="alert alert-success fade show mt-3">
                  {res.data.msg}
                </div>
              ),
            });
          }, 1000);
        } else {
          setTimeout(() => {
            this.setState({
              loading: "",
              errMsg: (
                <div className="alert alert-danger fade show mt-3">
                  {res.data.msg}
                </div>
              ),
            });
          }, 1000);
        }
      });
    // }
  }
  componentDidMount() {
    fetch(
      AppConstants.API + "/child/getChildProgram/" + this.props.match.params.id
    )
      .then((res) => {
        if (res.status == 200) {
          return res.json();
        }
      })
      .then((data) => {
        console.log(
          "436data",
          data.data.program[0].name,
          "_id",
          data.data.program[0]._id
        );
        this.setState({
          // name: data.data.name,
          // email: data.data.email,
          // address2: data.data.address2,
          // address1: data.data.address1,
          // phone: data.data.phone,
          // dob: data.data.date_of_birth,
          // graduatedate: data.data.graduation_year,
          // guardianphone: data.data.parent_phone,
          // guardian: data.data.parent_name,
          // guardianaddress:data.data.parent_address,
          // guardianflang : data.data.parent_flang,
          // gender: data.data.gender,
          // flanguage: data.data.firstlanguage,
          // organization : data.data.organization,
          // grade:data.data.grade,
          // school:data.data.school,
          // status : data.data.status,
          // guardianemail : data.data.parent_email,
          // usertype :data.data.user_type,
          // to_be_mentor : data.data.to_be_mentor,
          program: data.data.program[0]._id,
          pastProgram: data.data.program[0]._id,
          // city : data.data.city,
          // state : data.data.state,
          // zipcode : data.data.zipcode
        });
      });
    fetch(AppConstants.API + "/programs/getAllactiveprograms")
      .then((res) => {
        if (res.status == 200) {
          return res.json();
        }
      })
      .then((result) => {
        console.log("result", result);
        this.setState({ programs: result.data });
      });
    // fetch(AppConstants.API+'/language/getActivelanguges').then(res=>{
    //     if(res.status == 200){
    //         return res.json();
    //     }
    // }).then(result=>{
    //     this.setState({languages:result.data})
    // })
    var element = document.getElementById("navItem-Students-0");
    element.classList.add("active");
  }
  render() {
    return (
      <Page
        title="Edit Student program" /*breadcrumbs={[{ name: 'Call Center', active: true }]}*/
      >
        <ul className="cst-breadcrumb">
          <li>
            <Link to={"/dashboard"}>Dashboard</Link>
          </li>
          <li>
            <Link to={"/allChildren"}>All Students</Link>
          </li>
          <li>Edit Student program</li>
        </ul>
        <ReactTitle title="Edit Student program" />
        <Row className="edit-child">
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <Form name="addchild" onSubmit={this.handleSubmit}>
                  {/* <FormGroup row>
                                        <Label for="usertype" sm={2}>
                                           Please select type<span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="select"
                                            name="usertype"
                                            placeholder="Name"                      
                                            value={this.state.usertype}
                                            onChange={ this.handleInputChange }   
                                            ref ="usertype"           
                                            >
                                                <option value="">Select</option>
                                                <option value="Alumni">Alumni </option>
                                                <option value="Student">Student</option>
                                            </Input>
                                            {this.state.usertype_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["usertype"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="name" sm={2}>
                                            Name <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="text"
                                            name="name"
                                            placeholder="Name"                      
                                            value={this.state.name}
                                            onChange={ this.handleInputChange }  
                                            autoComplete="nope" 
                                            ref ="name"           
                                            />
                                            {this.state.nameError == true ? <span className="error" style={{color: 'red'}}>{this.state.errors["name"]}</span>:""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="gender" sm={2}>
                                            Gender <span>*</span>
                                        </Label>
                                        <Col lg={10} >
                                            <div className="d-flex justify-content-left">
                                                <FormGroup check className="mr-3">
                                                <Label check>
                                                    <Input type="radio"  name="gender" value="female" 
                                                        checked={this.state.gender=='female' } ref ="gender"  
                                                        onChange={ this.handleInputChange }/>Female
                                                </Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input type="radio"  name="gender" value="male" ref ="gender" 
                                                            checked={this.state.gender=='male'}
                                                            onChange={ this.handleInputChange }/>Male
                                                   </Label>
                                                </FormGroup>
                                                {this.state.gender_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["gender"]}</span> : ""}
                                           </div>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="organization" sm={2}>
                                            Organization <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="text"
                                            name="organization"
                                            placeholder="Organization"                      
                                            value={this.state.organization}
                                            onChange={ this.handleInputChange }   
                                            ref ="organization"           
                                            />
                                            {this.state.organization_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["organization"]}</span>:""}
                                        </Col>
                                    </FormGroup>
                                    {/* Proposed graduation month/year */}
                  {/* <FormGroup row>
                                        <Label for="graduatedate" sm={2}>
                                        Graduation month/year<span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                        <DatePicker
                                            name="graduatedate"
                                            className="form-control"
                                            placeholderText="MM/DD/YYYY"
                                            selected={this.state.graduatedate}
                                            selectsStart
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            onChange={this.handleStartdateChange}
                                            autoComplete = "off"
                                            minDate={new Date().setFullYear(new Date().getFullYear() - 20)}
                                            maxDate={new Date()}
                                        />
                                        <i className="fa fa-calendar" aria-hidden="true"></i>
                                        {this.state.graduatedate_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["graduatedate"]}</span>:""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="dob" sm={2}>
                                            Date of Birth <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                        <DatePicker
                                            name="dob"
                                            className="form-control"
                                            placeholderText="MM/DD/YYYY"
                                            selected={this.state.dob}
                                            selectsStart
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            onChange={this.handleDateofbirth}
                                            autoComplete = "off"
                                            maxDate={new Date()}
                                        />
                                        <i className ="fa fa-calendar" aria-hidden="true"></i>
                                        {this.state.dob_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["dob"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="school" sm={2}>
                                            School <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="text"
                                            name="school"
                                            placeholder="School"                      
                                            value={this.state.school}
                                            onChange={ this.handleInputChange }   
                                            ref ="school"           
                                            />
                                            {this.state.school_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["school"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="grade" sm={2}>
                                            Grade <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="text"
                                            name="grade"
                                            placeholder="Grade"                      
                                            value={this.state.grade}
                                            onChange={ this.handleInputChange }   
                                            ref ="grade"           
                                            />
                                           { this.state.grade_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["grade"]}</span>:""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="email" sm={2}>
                                            Email  <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="text"
                                            name="email"
                                            placeholder="Email"                      
                                            value={this.state.email}
                                            onChange={ this.handleInputChange }   
                                            ref ="email"
                                            onBlur = {this.handlechildmail.bind(this)}           
                                            />
                                            {this.state.email_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["email"]}</span> : ""}
                                            {this.state.email_error1 == true ? <span className="error" style={{color: 'red'}}>{this.state.errors1["email"]}</span>:""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="address1" sm={2}>
                                            Address1  <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="text"
                                            name="address1"
                                            placeholder="Address1"                      
                                            value={this.state.address1}
                                            onChange={ this.handleInputChange }   
                                            ref ="address1"           
                                            />
                                            {this.state.address_error1 == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["address1"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="address2" sm={2}>
                                            Address2  <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="text"
                                            name="address2"
                                            placeholder="Address2"                      
                                            value={this.state.address2}
                                            onChange={ this.handleInputChange }   
                                            ref ="address2"           
                                            />
                                            {this.state.address_error2 == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["address2"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="state" sm={2}>
                                           State <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="select"
                                            name="state"
                                            value={this.state.state}
                                            onChange={ this.handleInputChange }  
                                            ref ="state"                  
                                            > 
                                                <option value="">Select State</option>
                                                <option value="Alabama">Alabama</option>
                                                <option value="Alaska">Alaska</option>
                                                <option value="Arizona">Arizona</option>
                                                <option value="Arkansas">Arkansas</option>
                                                <option value="California">California</option>
                                                <option value="Colorado">Colorado</option>
                                                <option value="Connecticut">Connecticut</option>
                                                <option value="Delaware">Delaware</option>
                                                <option value="District Of Columbia">District Of Columbia</option>
                                                <option value="Florida">Florida</option>
                                                <option value="Georgia">Georgia</option>
                                                <option value="Hawaii">Hawaii</option>
                                                <option value="Idaho">Idaho</option>
                                                <option value="Illinois">Illinois</option>
                                                <option value="Indiana">Indiana</option>
                                                <option value="Iowa">Iowa</option>
                                                <option value="Kansas">Kansas</option>
                                                <option value="Kentucky">Kentucky</option>
                                                <option value="Louisiana">Louisiana</option>
                                                <option value="Maine">Maine</option>
                                                <option value="Maryland">Maryland</option>
                                                <option value="Massachusetts">Massachusetts</option>
                                                <option value="Michigan">Michigan</option>
                                                <option value="Minnesota">Minnesota</option>
                                                <option value="Mississippi">Mississippi</option>
                                                <option value="Missouri">Missouri</option>
                                                <option value="Montana">Montana</option>
                                                <option value="Nebraska">Nebraska</option>
                                                <option value="Nevada">Nevada</option>
                                                <option value="New Hampshire">New Hampshire</option>
                                                <option value="New Jersey">New Jersey</option>
                                                <option value="New Mexico">New Mexico</option>
                                                <option value="New York">New York</option>
                                                <option value="North Carolina">North Carolina</option>
                                                <option value="North Dakota">North Dakota</option>
                                                <option value="Ohio">Ohio</option>
                                                <option value="Oklahoma">Oklahoma</option>
                                                <option value="Oregon">Oregon</option>
                                                <option value="Pennsylvania">Pennsylvania</option>
                                                <option value="Rhode Island">Rhode Island</option>
                                                <option value="South Carolina">South Carolina</option>
                                                <option value="South Dakota">South Dakota</option>
                                                <option value="Tennessee">Tennessee</option>
                                                <option value="Texas">Texas</option>
                                                <option value="Utah">Utah</option>
                                                <option value="Vermont">Vermont</option>
                                                <option value="Virginia">Virginia</option>
                                                <option value="Washington">Washington</option>
                                                <option value="West Virginia">West Virginia</option>
                                                <option value="Wisconsin">Wisconsin</option>
                                                <option value="Wyoming">Wyoming</option>
                                            </Input>
                                            {this.state.state_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["state"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="city" sm={2}>
                                        City  <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="text"
                                            name="city"
                                            placeholder="City"                      
                                            value={this.state.city}
                                            onChange={ this.handleInputChange }   
                                            ref ="city"           
                                            />
                                            {this.state.city_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["city"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="zipcode" sm={2}>
                                        Zipcode  <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                        <NumberFormat
                                            format="######"
                                            mask=""
                                            type="text"
                                            name="zipcode"
                                            placeholder="Zipcode"                      
                                            value={this.state.zipcode}
                                            onChange={ this.handleInputChange }   
                                            ref ="zipcode" 
                                            className="form-control"          
                                            />
                                            {this.state.zipcode_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["zipcode"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="phone" sm={2}>
                                            Phone  <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                        <NumberFormat
                                        format="(###) ###-####"
                                        mask=""
                                        name="phone"
                                        placeholder="Phone Number"
                                        onValueChange={this.inputChangedHandlerContact}
                                        value={this.state.phone} className="form-control"
                                        autoComplete="nope"
                                        ref ="phone"
                                        />
                                       { this.state.phone_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["phone"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="flanguage" sm={2}>
                                            First Language  <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                        <Input
                                        type="select"
                                        name="flanguage"
                                        placeholder="First Language"
                                        value={this.state.flanguage}
                                        onChange={ this.handleInputChange }  
                                        ref ="flanguage"                  
                                        > 
                                            <option value="">Select Language</option>
                                            {this.state.languages.map((lang)=>{
                                                return(<option value={lang.name}>{lang.name}</option>)
                                            })}
                                        </Input>
                                        {this.state.flanguage_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["flanguage"]}</span> : ""}
                                        </Col>
                                    </FormGroup>\ */}
                  <FormGroup row>
                    <Label for="program" sm={2}>
                      Program <span>*</span>
                    </Label>
                    <Col sm={10}>
                      <Input
                        type="select"
                        name="program"
                        value={this.state.program}
                        onChange={this.handleInputChange}
                        ref="program"
                      >
                        {/* <option value="">Select Program</option> */}
                        {this.state.programs.map((program) => {
                          console.log("program860", program._id);
                          return (
                            <option value={program._id}>{program.title}</option>
                          );
                        })}
                      </Input>
                      {this.state.program_error == true ? (
                        <span className="error" style={{ color: "red" }}>
                          {this.state.errors["program"]}
                        </span>
                      ) : (
                        ""
                      )}
                    </Col>
                  </FormGroup>
                  {/* <FormGroup row>
                                        <Label for="guardian" sm={2}>
                                            Parent/Caregiver Name  <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="text"
                                            name="guardian"
                                            placeholder="Parent/Caregiver Name"
                                            readOnly                
                                            value={this.state.guardian}
                                            onChange={ this.handleInputChange }   
                                            ref ="guardian"           
                                            />
                                            {this.state.guardian_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["guardian"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="guardianemail" sm={2}>
                                            Parent/Caregiver Email {this.state.years < 18 ? <span>*</span> : ""}
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="text"
                                            name="guardianemail"
                                            placeholder="Parent/Caregiver Email"                      
                                            value={this.state.guardianemail}
                                            onChange={ this.handleInputChange }   
                                            onBlur = {this.handleparentmail.bind(this)}    
                                            ref ="guardianemail" 
                                            readOnly          
                                            />
                                            {this.state.guardianemail_error == true ?<span className="error" style={{color: 'red'}}>{this.state.errors["guardianemail"]}</span>:""}
                                            {this.state.guardianemail_error1 == true ?<span className="error" style={{color: 'red'}}>{this.state.errors1["guardianemail"]}</span>:""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="guardianphone" sm={2}>
                                            Parent/Caregiver phone number   <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <NumberFormat
                                            format="(###) ###-####"
                                            mask=""
                                            name="guardianphone"
                                            readOnly 
                                            placeholder="Parent/Caregiver phone number"  
                                            onChange = {this.handleInputChange} 
                                            value={this.state.guardianphone}
                                            className="form-control"
                                            ref ="guardianphone"
                                            autoComplete="nope"
                                            />
                                            {this.state.guardianphone_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["guardianphone"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    
                                    <FormGroup row>
                                        <Label for="guardianaddress" sm={2}>
                                            Parent/Caregiver Address  <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                            <Input
                                            type="text"
                                            name="guardianaddress"
                                            placeholder="Parent/Caregiver Address"
                                            readOnly                        
                                            value={this.state.guardianaddress}
                                            onChange={ this.handleInputChange }   
                                            ref ="guardianaddress"           
                                            />
                                            {this.state.guardianaddress_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["guardianaddress"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="flanguage" sm={2}>
                                            First Language  <span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                        <Input
                                            type="select"
                                            name="guardianflang"
                                            placeholder="First Language"
                                            value={this.state.guardianflang}
                                            onChange={ this.handleInputChange }  
                                            // readOnly
                                            ref ="guardianflang"                  
                                        > 
                                            <option value="">Select Language</option>
                                            {this.state.languages.map((lang)=>{
                                                return(<option value={lang.name}>{lang.name}</option>)
                                            })}
                                        </Input>
                                        { this.state.guardianflang_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["guardianflang"]}</span> : ""}
                                        </Col>
                                    </FormGroup>
                                    {this.state.usertype =="Alumni" ?
                                    <span>
                                    <FormGroup>
                                    <label>Are you interested in being a peer mentor? (only question for)  </label>
                                    <div>
                                        <input type="radio"  name="to_be_mentor" value="Yes" 
                                            checked={this.state.to_be_mentor=='Yes' } ref ="to_be_mentor"  
                                            onChange={ this.handleInputChange }/>
                                        <label for="radio5">Yes</label>&nbsp;&nbsp;
                                        <input type="radio"  name="to_be_mentor" value="No" ref ="to_be_mentor" 
                                            checked={this.state.to_be_mentor=='No'}
                                            onChange={ this.handleInputChange }/>
                                        <label for="radio6">No</label><br/>
                                        {this.state.to_be_mentor_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["to_be_mentor"]}</span> : ""}
                                    </div>
                                    </FormGroup></span>
                                         : ""}
                                    <FormGroup row>
                                        <Label for="status" sm={2}>
                                            Status<span>*</span>
                                        </Label>
                                        <Col sm={10}>
                                        <Switch onChange={this.handleChange} checked={this.state.status}
                                            onColor = "#45b649"
                                            offColor = "#ffd700"
                                            width	= {120}
                                            ref ="status" 
                                        />
                                        {this.state.status_error == true  ? <span className="error" style={{color: 'red'}}>{this.state.errors["status"]}</span> : ""}
                                        </Col>
                                    </FormGroup>*/}
                  <FormGroup check row>
                    <Col sm={{ size: 10, offset: 2 }}>
                      <Button
                        className="btn btn-primary"
                        onClick={this.handleSubmit}
                      >
                        Update
                        <div
                          style={this.state.loading ? {} : { display: "none" }}
                          className="image-fill w-25 loader-div"
                        >
                          <img
                            src={Loading}
                            alt="No Image"
                            className="can-click "
                          />
                        </div>
                      </Button>
                      &nbsp;
                      <Link
                        to={"/allChildren"}
                        className="btn btn-danger"
                        title="Cancel"
                      >
                        &nbsp;Cancel
                      </Link>
                    </Col>
                  </FormGroup>
                  {this.state.errMsg}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});
export default connect(mapStateToProps, {})(EditChild);
